import moment from 'moment'
import 'moment/locale/ar'

export const getDate = (date) => moment(date).format('D MMMM YYYY')
export const getTime = (dateTime) => moment(dateTime).format('h:mm a')
